import { useQuery, useMutation, useQueryClient } from "react-query";
import { fetchData } from "../api/client";
import { workspaceScopedQueryKey } from "../utils/workspaceQueryScope";

/**
 * Lê e atualiza o perfil do usuário logado.
 * GET  /users/me
 * PUT  /users/me  { nome, email, celular, imagem, tema, notification_prefs_json, ... }
 */
export const useMe = () => {
  const qc = useQueryClient();

  const me = useQuery(
    workspaceScopedQueryKey("me"),
    () => fetchData("/users/me"), // deve retornar { id, nome, email, celular, imagem, tema_default, ... }
    {
      staleTime: 10000,
      refetchOnWindowFocus: false,
      select: (res) => res || {},
    }
  );

  const save = useMutation(
    (payload) => fetchData("/users/me", "PUT", payload),
    {
      onSuccess: (data) => {
        qc.invalidateQueries(workspaceScopedQueryKey("me"));
        qc.invalidateQueries(["users"]); // caso alguma lista dependa
      },
    }
  );

  return { me, save };
};
